/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';

import DownloadTarget from '../../support/DownloadTarget';

import { MarketSelector, Text, ExportModal } from '../uiold';
import { themeColors } from '../uiold/Constants';
import mapToPlainObject from '../../support/mapToPlainObject';

import { Account } from '../../types/shared/Account';
import { Market } from '../../types/shared/Market';
import { Season } from '../../types/shared/Season';

type Props = {
  account: Account | null | undefined;
  season: Season | null | undefined;
  markets: Array<Market>;
  onDismiss: () => void;
};

type State = {
  isLoading: boolean;
  selectedMarketDates: Map<string, Set<string>>;
};

class ExportSalesDialog extends Component<Props, State> {
  state: State = {
    isLoading: false,
    selectedMarketDates: new Map(),
  };

  render() {
    let { isLoading } = this.state;
    return (
      <ExportModal
        title="Export Redemptions"
        isLoading={isLoading}
        onSubmit={this._initiateExport}
        onClose={this._onModalClosePress}
      >
        {this._renderMarketDatesFormField()}
      </ExportModal>
    );
  }

  _renderMarketDatesFormField = () => {
    return (
      <View style={styles.formSection}>
        <Text style={styles.paneHeader}>Markets and Dates</Text>
        <Text type="label" style={styles.paneText}>
          Export redemptions with selected markets and dates
        </Text>
        {this._renderMarketDateCheckboxes()}
      </View>
    );
  };

  _renderMarketDateCheckboxes = (): React.ReactNode => {
    let { selectedMarketDates } = this.state;
    let { markets } = this.props;
    return markets.map((market) => (
      <MarketSelector
        key={market.id}
        marketTitle={market.name}
        dates={market.dates}
        selectedItems={selectedMarketDates.get(market.id) || new Set()}
        onSelectAll={() => {
          this._selectAllMarketDates(market.id);
        }}
        onChange={(selectedKey: string) =>
          this._updateColumnMarketDates(market.id, selectedKey)
        }
      />
    ));
  };

  _updateColumnMarketDates = (marketID: string, selection: string) => {
    let { selectedMarketDates } = this.state;
    let oldSet = selectedMarketDates.get(marketID);
    let newSet = new Set(oldSet);
    newSet.has(selection) ? newSet.delete(selection) : newSet.add(selection);

    let oldMap = new Map(selectedMarketDates);
    let newMap = oldMap.set(marketID, newSet);

    this.setState({ selectedMarketDates: newMap });
  };

  _selectAllMarketDates = (marketID: string) => {
    let allMarketDates = getAllMarketDates(this.props.markets);
    let { selectedMarketDates } = this.state;
    let oldSet = new Set(selectedMarketDates.get(marketID));
    let newSet =
      oldSet.size > 0
        ? new Set<string>()
        : new Set(allMarketDates.get(marketID));
    let oldMap = new Map(selectedMarketDates);
    let newMap = oldMap.set(marketID, newSet);
    this.setState({ selectedMarketDates: newMap });
  };

  _selectAll = (columnName: string) => {
    let oldSet = this.state[columnName as keyof State] as Map<
      string,
      Set<string>
    >;
    let newSet =
      oldSet.size > 0
        ? new Set<string>()
        : new Set(this._selectGetter(columnName));

    this.setState({ [columnName]: newSet } as any);
  };

  _selectGetter = (columnName: string) => {
    switch (columnName) {
      default:
        return new Set() as Set<string>;
    }
  };

  _initiateExport = () => {
    let { selectedMarketDates } = this.state;
    let { account, season } = this.props;
    let data = {
      authToken: account ? account.token : undefined,
      seasonID: season ? season.id : undefined,
      selectedMarketDates: mapToPlainObject(selectedMarketDates, (dates) =>
        Array.from(dates),
      ),
    };
    DownloadTarget.post('/api/redemptions/export', data);
  };

  _onModalClosePress = () => {
    this.props.onDismiss();
  };
}

function getAllMarketDates(markets: Array<Market>): Map<string, Set<string>> {
  let marketDatesMap = new Map();
  markets.forEach((market) => {
    marketDatesMap.set(market.id, new Set(market.dates));
  });
  return marketDatesMap;
}

let styles = StyleSheet.create({
  formSection: {
    paddingHorizontal: 30,
    paddingTop: 10,
    paddingBottom: 20,
    borderBottomWidth: StyleSheet.hairlineWidth * 2,
    borderColor: themeColors.lightGrey,
  },
  paneHeader: {
    marginBottom: 8,
    fontWeight: '600',
    color: themeColors.darkGrey,
  },
  paneText: {
    color: themeColors.darkGrey,
  },
});

export default ExportSalesDialog;
